import RequestService from './request-service';

/**
 * Get all available sports data
 */
export default class AllSportsService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Api endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.getAllSports;
    /**
     * Request method
     * @type {string}
     */
    this.method = 'get';
    /**
     * Player language
     * @type {string}
     */
    // eslint-disable-next-line no-undef
    this.addGetParam('Culture', this.$config.defaultHeaders.Culture);
    this.headers = null;
  }
}
